module.exports = __webpack_public_path__ + "static/media/hide.751cb806.svg";